import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import Fade from 'react-reveal/Fade';
import { trackPage, trackContent } from '../utils/tracking';

// components
import Button from '../components/common/button';

// actions
import { getBeerBySlug } from '../actions';

// svg
import share from '../assets/svg/icon-share.svg';
import backArrow from '../assets/svg/back-arrow.svg';

class SingleBeer extends Component {
  state = {
    loading: true,
    beer: {}
  };

  componentWillMount() {
    window.scrollTo(0, 0);
  }

  componentDidMount() {
    const { state = null, pathname } = this.props.location;

    if (state && state.beer) {
      return this.setState({ loading: false, beer: state.beer });
    } else {
      getBeerBySlug(pathname).then(info =>
        this.setState({ beer: info.data, loading: false })
      );
    }

    //window.scrollTo(0, 0);
    trackPage();

    if (state) {
      trackContent(state.beer.name);
    } else {
      trackContent(pathname);
    }
  }

  render() {
    const { beer } = this.state;

    return (
      <main id="single-beer" className="textured">
        <Helmet>
          <title>{` ${beer.name} | ${beer.style}`}</title>
          <meta name="description" content={beer.style} />
          <meta property="og:title" content={` ${beer.name} | ${beer.style}`} />
          <meta property="og:description" content={beer.description} />
          <meta property="og:image" content={beer.glass_image} />
          {beer && beer.share_url && (
            <meta property="og:url" content={beer.share_url} />
          )}
          {beer && beer.beer_gif && (
            <meta property="og:video" content={beer.beer_gif} />
          )}
          <meta property="og:video:height" content={444} />
          <meta property="og:video:width" content={249} />
        </Helmet>

        <div className="beer-hero">
          <div className="container">
            <Fade casecade>
              <div className="beer-hero__featured">
                <div className="beer-hero__glass">
                  <img src={beer.glass_image} alt={beer.name} />
                </div>
                <div className="beer-hero__status">
                  {beer.on_tap ? 'Pouring Now' : 'Not Pouring'}
                </div>
                <div className="beer-hero__bg" />
                {beer && beer.share_url && (
                  <div className="beer-hero__share">
                    <a
                      href={`https://www.facebook.com/sharer/sharer.php?u=${
                        beer.share_url
                      }`}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      <img src={share} alt="share icon" />
                      <p>Share this beer</p>
                    </a>
                  </div>
                )}
              </div>
            </Fade>
            <Fade bottom cascade>
              <div className="beer-hero__detail">
                <h1 className="beer-hero__name">{beer.name}</h1>
                <div className="detail-inner">
                  <h2 className="beer-hero__abv">{beer.abv}%</h2>
                  <p className="beer-hero__style">{beer.style}</p>
                </div>
              </div>
            </Fade>
          </div>
        </div>
        <div className="beer-description">
          <Fade bottom>
            <h3 className="heading heading--super orange">Description</h3>
            <div className="beer-description__content">
              <p>{beer.description}</p>
            </div>
          </Fade>
        </div>

        <div className="beer-images">
          {beer && beer.beer_gif && (
            <video playsInline autoPlay loop muted height={444}>
              <source src={beer.beer_gif} type="video/mp4" />
            </video>
          )}

          {beer && beer.large_photo && (
            <div
              className="beer-images__large"
              style={{ backgroundImage: `url(${beer.large_photo})` }}
            />
          )}
        </div>

        <div className="beer-archives">
          <img src={backArrow} alt="back arrow" />

          <Button type="link" action="/beers">
            All Beers
          </Button>
        </div>
      </main>
    );
  }
}

export default SingleBeer;



// WEBPACK FOOTER //
// ./src/containers/SingleBeer.js